<template>
  <form class="form-inline" @submit.prevent>
    <div class="form-group mx-sm-3 mb-2 tenant-modifier">
      <select v-if="isAdmin" class="form-control" id="changeTenant" v-model="tenant">
        <option value="" disabled>Select Tenant...</option>
        <option v-for="tenant in userTenants" :key="tenant.identifier" :value="tenant.identifier">
          {{ tenant.name }} {{ tenant.inactive ? "(inactive)" : "" }}
        </option>
      </select>
      <input
        v-else
        class="form-control"
        type="text"
        placeholder="Change Tenant"
        id="changeTenant"
        v-model="tenant"
      />
    </div>
    <button class="btn mb-2 tenant-btn" @click="setTenant">Apply</button>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'
import { routesNames } from '@/core/constants'

export default {
  mounted() {},
  data() {
    return {
      tenant: ''
    }
  },
  created() {
    this.getUserTenants()
  },
  computed: {
    ...mapGetters(['isAdmin', 'userTenants'])
  },
  methods: {
    getUserTenants() {
      this.$store.dispatch('getUserTenants')
    },
    setTenant() {
      if (this.tenant !== '') {
        this.$store.commit('setCurrentTenant', this.tenant)
      }
      this.getData()
    },
    getData() {
      if (this.$route.name === routesNames.auditLogs) {
        this.$store.dispatch('getAuditLogs')
        return
      }

      if (this.$route.name === routesNames.history) {
        this.$store.dispatch('getHistoryRecords')
        return
      }

      this.$store.dispatch('getEditorData')
    }
  }
}
</script>

<style scoped>
button {
  margin: 5px;
}

.tenant-modifier {
  display: inline-block;
  margin-bottom: 0;
}

.tenant-btn {
    background-color: #E8E9F3;
    border-color: #31493D;
}
</style>



// WEBPACK FOOTER //
// src/components/TenantModifier.vue